module.exports = __webpack_public_path__ + "img/M0040.a554eb59.png";